module.exports = {
  "country": "ES",
  "artist": "Chanel",
  "song": "Slomo",
  "year": "2022",
  "place": "3",
  "spotify": "0T71AvVXY4RB65tvdIyzdO"
};